import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "hococo-spinner" }
const _hoisted_2 = {
  key: 0,
  src: "/img/spinner.svg",
  alt: "spinner",
  onload: "SVGInject(this)",
  class: "hococo-image-spinner"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "three-quarter-spinner" }, null, -1)
const _hoisted_4 = [
  _hoisted_3
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    ($props.logoSpinner)
      ? (_openBlock(), _createElementBlock("img", _hoisted_2))
      : (_openBlock(), _createElementBlock("div", {
          key: 1,
          class: _normalizeClass({'spinner-box': $props.withBox})
        }, _hoisted_4, 2))
  ]))
}